export default [
    "https://flatchooser.carco.hu",
    "https://flatchooser.reeltime.no"
]
